__turbopack_context__.v({
  "controlButton": "FeaturePreview-module-scss-module__yaAzPq__controlButton",
  "controls": "FeaturePreview-module-scss-module__yaAzPq__controls",
  "fallbackIcon": "FeaturePreview-module-scss-module__yaAzPq__fallbackIcon",
  "noPreview": "FeaturePreview-module-scss-module__yaAzPq__noPreview",
  "previewFadeIn": "FeaturePreview-module-scss-module__yaAzPq__previewFadeIn",
  "previewMedia": "FeaturePreview-module-scss-module__yaAzPq__previewMedia",
  "previewText": "FeaturePreview-module-scss-module__yaAzPq__previewText",
  "previewWrapper": "FeaturePreview-module-scss-module__yaAzPq__previewWrapper",
  "visualContainer": "FeaturePreview-module-scss-module__yaAzPq__visualContainer",
});
